import { getDomainConfig } from './domainConfig';
import seoRoutes from './seoRoutes.json';

// Canonical/OG URLs are ALWAYS the canonical marketing host, regardless of
// which hostname is serving the page. corbelcap.ai, corbel-ai-pipeline.web.app
// and .firebaseapp.com serve this same corpus; deriving the canonical from the
// hostname put a second, conflicting rel=canonical in the rendered DOM on
// those hosts, which makes Google ignore both. domainConfig remains the source
// for on-page branding strings only.
function detectSiteUrl(): string {
  return 'https://www.returncatalyst.ai';
}

function detectSiteName(): string {
  const config = getDomainConfig();
  return config.productName;
}

export const SITE_URL = detectSiteUrl();
export const SITE_NAME = detectSiteName();
export const DEFAULT_OG_IMAGE = `${SITE_URL}/images/og/og-default.jpg`;

export function buildCanonicalUrl(path: string): string {
  const cleanPath = path.startsWith('/') ? path : `/${path}`;
  return `${SITE_URL}${cleanPath}`;
}

export interface PageSEO {
  title: string;
  description: string;
  canonical: string;
  keywords?: string;
  /** Absolute URL of the per-route 1200x630 OG card. */
  ogImage?: string;
}

// Single source of truth shared with scripts/prerender-seo-routes.mjs so the
// static prerendered meta and the runtime Helmet meta can never diverge.
export const PAGE_SEO: Record<string, PageSEO> = Object.fromEntries(
  Object.entries(seoRoutes.routes as Record<string, Omit<PageSEO, 'canonical'>>).map(
    ([routePath, meta]) => [routePath, { ...meta, canonical: routePath }]
  )
);


